<template>
  <v-container v-if="currentFormSubmission">
    <v-row>
      <v-col stretch>
        <v-breadcrumb
          class="justify-between"
          :items="breadcrumbFormSubmissionItems"
          :mobile="breadcrumbMobileItem"
        ></v-breadcrumb>
      </v-col>
    </v-row>
    <v-row>
      <v-col stretch class="pb-2">
        <v-title-bar
          :title="
            $t('settings.forms.titles.submission', {
              date: $h.formatDate(currentFormSubmission.created_at, teams[$route.params.team].account.timezone),
            })
          "
        >
        </v-title-bar>
      </v-col>
    </v-row>
    <v-row v-if="!currentFormSubmission.fields.length">
      <v-col>
        <div>{{ $t("settings.forms.placeholders.noFormResponses") }}</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="col-12 pb-0"
        :class="f.field && f.field.type !== 'checkbox' ? 'pt-6' : 'pt-2'"
        v-for="f in currentFormSubmission.fields"
        :key="f.uid"
      >
        <div v-if="f.field && f.field.type === 'htmlblock' && f.field.options.show_in_backoffice">
          <div class="text-v2-secondary-400 font-bold" v-html="$h.getLanguageValue(f.field.options.value)"></div>
        </div>
        <div v-if="f.field && f.field.type === 'input'">
          <div class="text-v2-secondary-400 font-bold">
            {{ $h.getLanguageValue(f.field.options.label) }}
          </div>
          <v2-textfield :value="f.value" disabled withoutFormError></v2-textfield>
        </div>
        <div v-if="f.field && f.field.type === 'textarea'">
          <div class="text-v2-secondary-400 font-bold">
            {{ $h.getLanguageValue(f.field.options.label) }}
          </div>
          <v2-textarea :value="f.value" disabled withoutFormError></v2-textarea>
        </div>
        <div v-if="f.field && f.field.type === 'select'">
          <div class="text-v2-secondary-400 font-bold">
            {{ $h.getLanguageValue(f.field.options.label) }}
          </div>
          <v2-select :value="f.value" :options="[]" disabled withoutFormError></v2-select>
        </div>
        <div v-if="f.field && f.field.type === 'checkbox'">
          <v2-checkbox
            :value="transformCheckboxValue(f.value)"
            :label="$h.getLanguageValue(f.field.options.label)"
            disabled
            withoutFormError
          ></v2-checkbox>
        </div>

        <div v-if="f.field && f.field.type === 'checkbox-group'">
          <div class="text-v2-secondary-400 font-bold">
            {{ $h.getLanguageValue(f.field.options.label) }}
          </div>
          <div>
            <v2-checkbox
              v-for="option in f.field.options.options"
              :key="option.name"
              :value="JSON.parse(f.value)[option.name]"
              :label="$h.getLanguageValue(option.label)"
              class="pr-4 pt-2"
              disabled
              withoutFormError
            ></v2-checkbox>
          </div>
        </div>

        <div v-if="f.field && f.field.type === 'radio-group'">
          <div class="text-v2-secondary-400 font-bold">
            {{ $h.getLanguageValue(f.field.options.label) }}
          </div>
          <div>
            <div class="v2-input v2-radio-group pt-2">
              <div v-for="option in f.field.options.options" :key="option.name">
                <label class="radio" :for="name"
                  >{{ $h.getLanguageValue(option.label) }}
                  <input
                    type="radio"
                    :id="f.field.name"
                    :name="f.field.name"
                    :value="name"
                    :checked="option.value === value"
                    disabled
                  />
                  <span class="checkmark"></span>
                  <slot></slot>
                </label>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "FormSubmission",
  data() {
    return {
      breadcrumbFormSubmissionItems: [
        {
          label: this.$t("menus.settings"),
          route: { name: "Settings", params: { tab: "account" } },
        },
        {
          label: this.$t("menus.forms"),
          route: { name: "Settings", params: { tab: "forms" } },
        },
      ],
      breadcrumbMobileItem: {
        label: this.$t("menus.forms"),
        route: { name: "Settings", params: { tab: "forms" } },
      },
    };
  },
  created() {
    this.loadPageData();
  },
  methods: {
    ...mapActions(["getFormSubmission", "getForm"]),
    loadPageData() {
      const vm = this;
      vm.$store.commit("GLOBAL_CUSTOM_LOADING_STARTED");
      vm.getForm({
        formFieldset: vm.$route.params.form,
        customLoading: true,
      }).then(() => {
        vm.breadcrumbFormSubmissionItems.push({
          label: vm.currentForm.name,
          route: { name: "Form", params: { uid: vm.currentForm.uid } },
        });
      });
      vm.getFormSubmission({
        formFieldset: vm.$route.params.form,
        formResponse: vm.$route.params.submission,
      })
        .then(() => {
          vm.breadcrumbFormSubmissionItems.push({
            label: vm.$h.formatDate(
              vm.currentFormSubmission.created_at,
              vm.teams[vm.$route.params.team].account.timezone
            ),
            active: true,
          });
          vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
        })
        .catch((err) => {
          console.log(err);
          vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
        });
    },
    transformCheckboxValue(val) {
      return (typeof val === "boolean" && val) || val.includes("1") || val.includes("true");
    },
  },
  computed: {
    ...mapGetters({
      teams: "auth_get_teams",
      teamsSettings: "global_get_teams_settings",
      currentForm: "forms_get_current_form",
      currentFormSubmission: "forms_get_current_form_submission",
    }),
  },
};
</script>
